import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Flags from "country-flag-icons/react/3x2";

import { toggleLoadingGlobal } from "../actions";

export default function LanguageSelector() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const changeLanguage = lng => {
    dispatch( toggleLoadingGlobal(true) );
    i18n.changeLanguage(lng);
    window.location.reload();
  };

  return (
    <div className="d-flex justify-content-evenly align-items-center">
      <div className="flagDiv" onClick={() => changeLanguage("fi")}><Flags.FI title={t("Finnish", "Suomi")} className="languageSelectorFlag" /></div>
      <div className="vr my-2" />
      <div className="flagDiv" onClick={() => changeLanguage("sv")}><Flags.SE title={t("Swedish", "Ruotsi")} className="languageSelectorFlag" /></div>
      <div className="vr my-2" />
      <div className="flagDiv" onClick={() => changeLanguage("nl")}><Flags.NL title={t("Dutch", "Hollanti")} className="languageSelectorFlag" /></div>
      <div className="vr my-2" />
      <div className="flagDiv" onClick={() => changeLanguage("en")}><Flags.GB title={t("English", "Englanti")} className="languageSelectorFlag" /></div>
    </div>
  );
}
